import { render, staticRenderFns } from "./GoodsGroupPreview.vue?vue&type=template&id=69991bfc&scoped=true&"
import script from "./GoodsGroupPreview.vue?vue&type=script&lang=js&"
export * from "./GoodsGroupPreview.vue?vue&type=script&lang=js&"
import style0 from "./GoodsGroupPreview.vue?vue&type=style&index=0&id=69991bfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69991bfc",
  null
  
)

export default component.exports